import { createAxiosClient } from "@ntg/component-library/utilities";
import type { IReadVerbPayload } from "../../declarations/IReadVerbPayload";

export interface IReleasedProductD365 {
    itemNumber: string;
    productNumber: string;
    dataAreaID: string;
    itemModelGroupId: string;
    productGroupId: string;
    productionType: string;
    defaultOrderType: string;
    salesPrice: number;
    purchasePrice: number;
    inventoryUnitSymbol: string;
    salesUnitSymbol: string;
    purchaseUnitSymbol: string;
    bomUnitSymbol: string;
    storageDimensionGroupName: string;
    trackingDimensionGroupName: string;
    costGroupId: string;
    costCalculationGroupId: string;
    productionPoolId: string;
    productCoverageGroupId: string;
    salesSalesTaxItemGroupCode: string;
    purchaseSalesTaxItemGroupCode: string;
    buyerGroupId: string;
    primaryVendorAccountNumber: string;
    isDeliveredDirectly: string;
    originCountryRegionId: string;
    intrastatCommodityCode: string;
}

export const getReleasedProductD365 = async (
    payload: IReadVerbPayload,
): Promise<IReleasedProductD365> => {
    const axiosAuth = createAxiosClient("D365FO");
    const response = await axiosAuth.post<IReleasedProductD365>(
        `/ReleasedProduct/GetReleasedProductD365`,
        payload,
    );
    return response.data;
};
